import styled, { css } from 'styled-components';
import { colors, monokaiBackground } from 'global/colors';

export const FreecodeTabContentContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;

  & :is(h1, h2, h3, h4, h5, h6) {
    color: ${colors.fsDarkBlue};
  }

  ${({ lightGradient }) =>
    lightGradient &&
    css`
      background: rgb(255, 255, 255);
      background: linear-gradient(180deg, ${colors.white} 0%, ${colors.fsLightBlue} 15%, ${colors.fsLightBlue} 100%);
    `}

  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      background-color: ${monokaiBackground};
      color: ${colors.lightGray};
      & :is(h1, h2, h3, h4, h5, h6) {
        color: ${colors.fsCyan};
      }

      & input {
        background-color: ${colors.darkGray};
        border-color: ${colors.lightGray2};
      }
      & input:disabled {
        background-color: ${monokaiBackground};
        border-color: ${colors.darkGray};
      }
      & input,
      & label,
      & span {
        color: ${colors.lightGray};
      }
    `};
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;

  & label {
    margin-bottom: 0;
  }
`;

export const ColumnContainer = styled.div`
  padding: 0 0.75rem;
  margin: 0 auto;
  flex: 50%;
  min-width: 310px;
`;

export const FormSection = styled.section`
  padding-top: 1rem;

  & .react-colorful {
    width: auto;
    height: 115px;
  }

  & .react-colorful__hue {
    width: auto;
    height: 15px;
  }

  & .react-colorful__saturation-pointer,
  & .react-colorful__hue-pointer,
  & .react-colorful__alpha-pointer {
    width: 20px;
    height: 20px;
  }

  ${({ paddingX }) =>
    paddingX &&
    css`
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    `}
`;

export const Title = styled.h3``;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
  gap: 0.5rem;
`;

export const Label = styled.label`
  font-size: 14px;

  color: ${colors.darkGray};

  ${({ hideOverflow }) =>
    hideOverflow &&
    css`
      text-align: left;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 100%;
    `}

  ${({ nowrap }) =>
    nowrap &&
    css`
      white-space: nowrap;
    `}
  ${({ displayBlock }) =>
    displayBlock &&
    css`
      display: block;
    `}
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  color: ${colors.darkGray};
  border: 1px solid ${colors.borderGray};
  border-radius: 0.25rem;
  &:focus {
    outline: 0;
  }
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: 0.75rem;
    `}
`;

export const NumberInput = styled.input.attrs({ type: 'number' })`
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  color: ${colors.darkGray};
  border: 1px solid ${colors.borderGray};
  border-radius: 0.25rem;
  &:focus {
    outline: 0;
  }
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: 0.75rem;
    `}
`;

export const HiddenFileInput = styled.input.attrs({ type: 'file' })`
  display: none;
`;
